<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="350">
      <template v-slot:activator="{ on }">
        <v-btn block :loading="dialog" color="success" v-on="on">Deposit</v-btn>
      </template>
      <v-card>
        <v-card-title class="success headline">Deposit Form</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <p
                  class="font-weight-black text-center black--text"
                  v-if="Deposit.amount"
                >
                  {{ Deposit.amountType | MoneySigns }}
                  {{ Deposit.amount.toLocaleString() }}
                </p>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.number.trim="Deposit.amount"
                  :rules="[v => !!v || 'Amount is required']"
                  name="DepositAmount"
                  label="Deposit Amount"
                  type="number"
                  prepend-icon="mdi-cash-multiple"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="Deposit.amount > 0">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-cash"
                  v-model.trim="Deposit.amountType"
                  :items="GetCashTypes"
                  :rules="[v => !!v || 'Cash Type is required']"
                  label="Cash Type"
                  required
                  no-data-text="Refresh the page"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  prepend-icon="mdi-calendar-month-outline"
                  v-model="Deposit.date"
                  :rules="[v => !!v || 'Deposit Date is required']"
                  required
                  name="DepDateFild"
                  label="Deposit Date"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="Deposit.details"
                  :rules="[v => !!v || 'Details is required']"
                  prepend-icon="mid-message-text-outline"
                  label="Details"
                  clearable
                  counter="100"
                  auto-grow
                  row-height="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="clicked" color="green darken-1" text @click="close"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!valid"
            :loading="clicked"
            color="green darken-1"
            text
            @click="OnDeposit"
            >Deposit</v-btn
          >
        </v-card-actions>
        <p class="text-center mt-2 red--text">{{ ErrorMsg }}</p>
        <!-- <p>{{ AccountNumber }}</p> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: { OwnerID: [String], Finished: [Function] },
  data() {
    return {
      valid: true,
      dialog: false,
      ErrorMsg: "",
      clicked: false,
      Deposit: {
        amount: null,
        amountType: null,
        AccountNumber: "",
        details: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.Deposit.date = this.Current().date;
    },
    OnDeposit() {
      this.ErrorMsg = "";
      if (this.$refs.form.validate()) {
        this.clicked = true;
        // this.Deposit.date = this.Current().date;
        this.Deposit.time = this.Current().time;
        this.Deposit.AccountNumber = this.OwnerID;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/owner/deposit",
            data: this.Deposit,
          })
          .then(result => {
            this.clicked = false;
            this.close();
            // console.log(result);

            this.Finished(result.data);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
            else this.ErrorMsg = err.response.data;
          });
      }
    },
  },
  mounted() {
    this.Deposit.date = this.Current().date;
  },
};
</script>
